var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZococheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #b3c300;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #b3c300;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: .25px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.13,139.73c-2.26-9.52-10.08-15.92-19.46-15.92-5.25,0-10.17,2.04-13.88,5.74l-98.53,98.53c-.39.39-1.09.39-1.48,0l-39.58-39.58c-3.7-3.71-8.63-5.75-13.87-5.75-9.44,0-17.27,6.44-19.48,16.02-1.38,5.94.57,12.44,5.08,16.95l54.72,54.72c3.7,3.71,8.63,5.75,13.88,5.75s10.18-2.04,13.88-5.75l113.67-113.67c4.54-4.54,6.48-11.07,5.06-17.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200,390.42c-105,0-190.42-85.42-190.42-190.42S95,9.58,200,9.58s190.41,85.42,190.41,190.41-85.42,190.42-190.41,190.42ZM200,33.17c-91.99,0-166.83,74.84-166.83,166.83s74.84,166.83,166.83,166.83,166.83-74.84,166.83-166.83S291.98,33.17,200,33.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZococheck);
export default __webpack_public_path__ + "static/media/Zoco check.41ba699085a259b96b76b66a6c66abfb.svg";
export { ForwardRef as ReactComponent };